module.exports = __webpack_public_path__ + "img/center.cd6bf9b5.jpg";